<script>
//
export let pageCopy;
export let pageTitle

let videoId;
let theTitle;

if (pageTitle !== null) {
    theTitle = pageTitle;

} else {
    theTitle = "";
}

  const video_Id = () => {
	  if(pageCopy?.startsWith("https://www.youtube.com/watch?v=")){
		  return pageCopy.split("=")[1];
	  }else if(pageCopy?.startsWith("https://youtu.be/")){
		  return pageCopy.split("/")[3];
	  }
  }

  videoId = video_Id();


</script>
<section>

    <div class="fic-video">
        <div class="video-container">
            <iframe
              width="100%" height="100%" 
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&vq=hd1080`}
              title="{theTitle}"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />

        </div>

    </div>



</section>